import React from 'react';
import PropTypes from 'prop-types';

import SEO from 'components/seo';
import MainLayout from 'layouts/main';

import { pageContainer } from './scss/Page.module.scss';
import 'styleguide/index.scss';

const Page = ({ layout: Layout, pageName, children, pageData }) => {
  return (
    <Layout>
      <SEO pageName={pageName} pageData={pageData} />
      <div className={pageContainer}>{children}</div>
    </Layout>
  );
};

Page.propTypes = {
  pageName: PropTypes.string.isRequired,
  pageData: PropTypes.object,
  layout: PropTypes.func,
  children: PropTypes.node,
};

Page.defaultProps = {
  layout: MainLayout,
  children: null,
};

export default Page;
